import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ModeProps } from '../types';
import { Hero } from '../components/sections/Hero';
import { ProductSuite } from '../components/sections/ProductSuite';
import { BenefitsGrid } from '../components/sections/BenefitsGrid';
import { UseCases } from '../components/sections/UseCases';
import { Features } from '../components/sections/Features';
import { HowItWorks } from '../components/sections/HowItWorks';
import { TrustSection } from '../components/sections/TrustSection';
import { FinalCTA } from '../components/sections/FinalCTA';
export function HomePage({
  mode
}: ModeProps) {
  return <main className="flex-grow pt-16" data-id="element-2384">
      <Hero mode={mode} data-id="element-2385" />

      <AnimatePresence mode="wait" data-id="element-2386">
        {mode === 'business' ? <motion.div key="business-content" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-2387">
            <ProductSuite data-id="element-2388" />
            <UseCases data-id="element-2389" />
          </motion.div> : <motion.div key="individual-content" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-2390">
            <BenefitsGrid data-id="element-2391" />
            <Features data-id="element-2392" />
          </motion.div>}
      </AnimatePresence>

      <HowItWorks mode={mode} data-id="element-2393" />
      <TrustSection mode={mode} data-id="element-2394" />
      <FinalCTA mode={mode} data-id="element-2395" />
    </main>;
}